module.exports = __webpack_public_path__ + "img/fast-transactions2x.5151dcaf.png";